import React,{ useEffect } from 'react';
import { inject, observer } from "mobx-react";
import _useTranslate from '../../hooks/_useTranslate';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import GreenSubmitButton from '../../buttons/greenSubmitButton';
import { useNavigate } from 'react-router-dom';
import Colors from '../../assets/colors';
import "./Checkout.css";


const Fail = ({ feathersStore })=> {

  const redColored = {
    color: "hsl(0, 67.20%, 37.10%)", 
    fontSize: 80, 
    marginTop: 10, 
    marginBottom: 10
  };
  let common = _useTranslate(feathersStore.language, "common"); 
  let navigate = useNavigate();  

  useEffect(() => {
    const asyncFn = async() => {
      await feathersStore.setObservables();    
      feathersStore.setLanguage(localStorage.getItem('Language'));
      feathersStore.setOrderItem({});
      localStorage.setItem('fdwa_orderItem', JSON.stringify({}));
  //   const fdwa_viva_created = localStorage.getItem('fdwa_viva_created');
  //   if(fdwa_viva_created?.length > 0)this.setVivaPaymentCreatedEvent(JSON.parse(fdwa_viva_created))
      feathersStore.fetchChatId();

      const _fdwaState = localStorage.getItem('fdwa_state');
      const fdwaState = JSON.parse(_fdwaState);
      feathersStore.setHasLocationPermission(fdwaState?.hasLocationPermission);
      feathersStore.setCartLength(fdwaState?.cartLength);
      feathersStore.setShowCookies(fdwaState?.showCookies);
      feathersStore.setTableId(fdwaState?.tableId ?? 'eshop');
      feathersStore.setRestaurantOpen(fdwaState?.restaurantOpen);
      feathersStore.setShowRestaurantMessage(fdwaState?.showRestaurantMessage);
      feathersStore.setDiscountsArray(fdwaState?.discountsArray);
      feathersStore.setCurrency(fdwaState?.currency);
      feathersStore.setOrderCode(null);
      localStorage.setItem('fdwa_state', JSON.stringify({}));
    }
    asyncFn();
  }, []);
  
  useEffect(() => {
   
      //---> Cleanup START
     
      feathersStore.setOrderItem({items: []});

      //<--- Cleanup END     
   
  }, [feathersStore.orderItem?.items])
  
  const goToCheckout = () => {
    navigate("/checkout")
  }

  return(
    <div className="body-container">
      <div className="grey-header">{common.unsuccessfulPayment}</div>
      <div className="success-container">
        <HighlightOffIcon sx={redColored}/>  
        <div className="fail-button-container">
          <GreenSubmitButton 
            onClick={goToCheckout}
            aria-label='Viva-btn' 
            width="300px"
            title={common.tryAgain}
            color={undefined}
          ></GreenSubmitButton>
        </div>
      
      </div>
    </div>
  )
}

export default inject('feathersStore')(observer(Fail));